import { Box } from "@mui/material";

function Label(props) {
  return (
    <Box mb={1}>
      <label
        style={{
          fontFamily: "open sans",
          fontWeight: "800",
          fontSize: 13,
          color: "#4F6F52",
        }}
        htmlFor={props.for}
      >
        {props.title}
      </label>
    </Box>
  );
}

export default Label;
